/* =========================================================
   Dolls In Love — Mediathek
   Alle Videos einzeln als Kacheln. Die Vorschaubilder liegen lokal,
   YouTube wird erst geladen, wenn jemand ein Video wirklich startet.
   ========================================================= */
(function () {
  'use strict';
  const raster = document.getElementById('tubeGrid');
  const box    = document.getElementById('tubeBox');
  const player = document.getElementById('tubePlayer');
  const titel  = document.getElementById('tubeTitel');
  const zu     = document.getElementById('tubeClose');
  const notiz  = document.getElementById('tubeNote');
  const tube   = document.getElementById('tube');
  if (!raster || !box || !tube) return;

  const VIDEOS = window.DIL_VIDEOS || [];
  const liste  = tube.dataset.playlist;

  const datum = s => {
    const t = String(s).split('-');
    return t.length === 3 ? t[2] + '.' + t[1] + '.' + t[0] : s;
  };

  raster.innerHTML = VIDEOS.map(function (v, i) {
    return '<button class="vkachel" type="button" data-i="' + i + '">' +
      '<span class="vkachel__bild"><img src="' + v.bild + '" alt="" loading="' + (i < 6 ? 'eager' : 'lazy') + '"></span>' +
      '<span class="vkachel__play" aria-hidden="true"></span>' +
      '<span class="vkachel__text">' +
        '<span class="vkachel__titel">' + v.titel + '</span>' +
        '<span class="vkachel__datum">' + datum(v.datum) + '</span>' +
      '</span></button>';
  }).join('');

  if (notiz) {
    notiz.innerHTML = VIDEOS.length + ' Filme vom Hersteller. Erst beim Abspielen wird eine Verbindung ' +
      'zu YouTube hergestellt. <a class="link-gold" href="https://www.youtube.com/playlist?list=' +
      liste + '" target="_blank" rel="noopener">Ganze Playlist bei YouTube &rarr;</a>';
  }

  function oeffne(v) {
    titel.textContent = v.titel;
    player.innerHTML = '';
    const f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + v.id + '?rel=0&modestbranding=1&autoplay=1';
    f.title = v.titel;
    f.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture; web-share';
    f.referrerPolicy = 'strict-origin-when-cross-origin';
    f.allowFullscreen = true;
    player.appendChild(f);
    box.hidden = false;
    requestAnimationFrame(function () { box.classList.add('is-in'); });
    document.body.style.overflow = 'hidden';
    zu.focus();
  }

  function schliesse() {
    box.classList.remove('is-in');
    document.body.style.overflow = '';
    setTimeout(function () { box.hidden = true; player.innerHTML = ''; }, 320);
  }

  raster.addEventListener('click', function (e) {
    const k = e.target.closest('button[data-i]');
    if (k) oeffne(VIDEOS[+k.dataset.i]);
  });
  zu.addEventListener('click', schliesse);
  box.addEventListener('click', function (e) { if (e.target === box) schliesse(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) schliesse(); });
})();
